enum PasswordResponses {
  NeedPassword = 1,
  IncorrectPassword = 2,
}

export default PasswordResponses;
